interface TeamMember {
  imagePath: string;
  profilePath: string;
  linkedinPath: string;
  name: string;
  title: string;
  description: string;
  shortDescription: string;
}

const teamMembers: TeamMember[] = [
  {
    imagePath: '/img/01_Ramon_Saltor.jpg',
    profilePath: 'ramon-saltor',
    linkedinPath: 'http://es.linkedin.com/in/ramonsaltor',
    name: 'Ramón Saltor',
    title: 'CEO',
    description: 'Ramón tiene experiencia en el sector financiero en Londres. Apasionado por las finanzas y la ' +
    'emprendeduría, en 2011 decide regresar a Barcelona para desarrollar una idea que lleva madurando desde hace ' +
    'unos años, una plataforma que combinara la solidez y estructura de los procesos financieros aplicados a la ' +
    'Banca Corporativa, el dinamismo del Crowdfunding y las incipientes redes de Business Angels en España. Así ' +
    'surge The Crowd Angel, pionero en combinar estos tres conceptos, y líder en equity crowdfunding en España. ' +
    'Ramon es licenciado en Comercio Internacional y Ciencias Empresariales.',
    shortDescription: 'Ramón tiene experiencia en el sector financiero en Londres',
  },
  {
    imagePath: '/img/02_Joaquim_Lopez.jpg',
    profilePath: 'joaquim-lopez',
    linkedinPath: 'http://es.linkedin.com/in/joaquimlopez',
    name: 'Joaquim López Caussa',
    title: 'Director de operaciones',
    description: 'Joaquim empezó su carrera profesional en el mundo del marketing de gran consumo como Brand ' +
    'Manager Assistant en Henkel y en Vileda, pero pronto decidió cambiarlo para dedicarse a dos de sus pasiones, ' +
    'la inversión y el emprendimiento. Después de trabajar para Rocket Internet en Londres como analista de ' +
    'inversiones y seguimiento de participadas, se ha unió al equipo The Crowd Angel para liderar el crecimiento ' +
    'de este proyecto ambicioso. Joaquim tiene una licenciatura y máster en Administración y Dirección de Empresas ' +
    'en ESADE y un Master in European Business en la ESCP Europe Business School y el Asian Institute of Technology',
    shortDescription: 'Joaquim empezó su carrera profesional en el mundo del marketing',
  },
  {
    imagePath: '/img/04_Ramon_Alvarez.jpg',
    profilePath: 'ramon-alvarez',
    linkedinPath: 'http://es.linkedin.com/in/ralvaroig',
    name: 'Ramón Álvarez',
    title: 'Director de inversiones',
    description: 'Ramón se incorporó al equipo de The Crowd Angel tras tres años en París trabajando primero en ' +
    'el equipo de estrategia del grupo AXA y más tarde como analista de fondos de inversión en AXA IM. Decide ' +
    'volver a Barcelona atraído por el ecosistema emprendedor e inversor, pensando en apoyar a startups con gran ' +
    'potencial en su ciudad de origen. Estudió doble licenciatura de Ingeniería de Telecomunicaciones en la UPC y ' +
    'Negocios Internacionales en Telecom Bretagne. También tiene un Máster en Política Europea en Science Po y otro ' +
    'en Finanzas de Mercado en la Universidad Paris Dauphine. Actualmente Ramón es candidato al nivel III del CFA.',
    shortDescription: 'Ramón se incorporó al equipo de The Crowd Angel tras tres años en París',
  },
  {
    imagePath: '/img/03_Victoria_Tormo.jpg',
    profilePath: 'victoria-tormo',
    linkedinPath: 'http://es.linkedin.com/in/victoriatormo',
    name: 'Victoria Tormo',
    title: 'Investor Care',
    description: 'Victoria comenzó su trayectoria profesional en Roche, la multinacional suiza especializada en ' +
    'biotecnología, específicamente en el Departamento de Comunicaciones para el Región Andina, Centroamérica y ' +
    'El Caribe, participando en gestión de comunicaciones internas y levantamiento de la intranet para planes ' +
    'futuros de reestructuración. Seguidamente, se unió a la agencia de comunicaciones corporativas Conecta ' +
    'Comunicaciones, allí, asistió el sector de consultoría estratégica y prestó soporte en el contacto con ' +
    'stakeholders. Su último paso profesional en el Departamento de Comunicaciones de General Electric Venezuela, ' +
    'en el que brindó apoyo en estrategias corporativas del negocio, le hizo interesarse por el sector tecnológico ' +
    'y automatización de procesos y, finalmente, decidir adentrarse en el mundo startup. Victoria tiene ' +
    'licenciatura en Comunicación Social, Mención Publicidad y Mercadeo de la Universidad Católica Andrés Bello.',
    shortDescription: 'Victoria comenzó su trayectoria profesional en Roche, la multinacional suiza',
  },
  {
    imagePath: '/img/05_Marc_Suris.jpg',
    profilePath: 'marc-suris',
    linkedinPath: 'http://es.linkedin.com/in/msurismarti',
    name: 'Marc Surís',
    title: 'Investment Analyst',
    description: 'Marc ha desarrollado su carrera profesional como ingeniero de telecomunicaciones durante 4 años en ' +
    'Dorna Sports, implicado en la producción televisiva de MotoGP.\n' +
    'Apasionado por las inversiones y el mundo emprendedor, Marc descubre The Crowd Angel como inversor. Después de ' +
    'un periodo de inversión en la plataforma, se ha unido al equipo de TCA para colaborar en el crecimiento de este ' +
    'proyecto ambicioso aportando una visión más técnica en el análisis de startups.\n' +
    'Marc es ingeniero de telecomunicaciones por la Universitat Politècnica de Catalunya. Fruto de su interés por ' +
    'las inversiones y las finanzas decidió formarse en este mundo a través del Máster en Finanzas Corporativas de ' +
    'la Universitat de Barcelona.',
    shortDescription: 'Marc ha desarrollado su carrera profesional como ingeniero de telecomunicaciones',
  },
  {
    imagePath: '/img/07_Alberto_de_Arana.jpg',
    profilePath: 'alberto-de-arana',
    linkedinPath: 'http://es.linkedin.com/in/alberto-de-arana-20bb5981',
    name: 'Alberto de Arana',
    title: 'Investment Analyst',
    description: 'Alberto tiene un grado en Administración y Dirección de Empresas por la universidad de ESADE. ' +
    'Inició su carrera profesional como analista de riesgo de crédito y como asesor financiero en Banca Privada en ' +
    'Abante Asesores. Atraído por el ecosistema emprendedor dio el salto a la Fintech ' +
    'Novicap trabajando en el área de ' +
    'desarrollo de negocio. Paralelamente, se involucró en varios proyectos tecnológicos ' +
    'asistiendo en la preparación de rondas de financiación y contacto con inversores, lo que le llevó a conocer ' +
    'The Crowd Angel y terminó uniéndose al equipo de analistas.',
    shortDescription: 'Alberto tiene un grado en Administración y Dirección de Empresas por la universidad',
  },
  {
    imagePath: '/img/08_Alex_Campi.jpg',
    profilePath: 'alex-campi',
    linkedinPath: 'https://www.linkedin.com/in/alex-campi-b02419140/',
    name: 'Alex Campi',
    title: 'Investor Manager',
    description: 'Alex inició su carrera profesional trabajando el en área de desarrollo de negocio en la ' +
    'Fintech NoviCap. Seguidamente se unió al equipo de TripAdvisor para implantar un nuevo producto en el país, ' +
    'donde estaba en contacto directo con el departamento de ventas y marketing. Se incorporó a The Crowd Angel ' +
    'con el objetivo de generar un valor añadido en la relación con los inversores y emprendedores. Alex tiene un ' +
    'grado en Administración y Dirección de Empresas por la Toulouse Business School.',
    shortDescription: 'Alex inició su carrera profesional trabajando el en área de desarrollo de negocio',
  },
  {
    imagePath: '/img/06_Fernando_Aguilar.jpg',
    profilePath: 'fernando-aguilar',
    linkedinPath: 'https://www.linkedin.com/in/fer-aguilar/',
    name: 'Fernando Aguilar',
    title: 'Lead designer',
    description: 'Fernando comenzó su trayectoria profesional en el estudio de diseño multimedia ElsAltres y en el ' +
    'estudio de ilustración Brosmind, en proyectos interactivos, postproducción gráfica e ilustración creativa. ' +
    'Posteriormente asumió el reto de ser el director de arte para ' +
    'grandes cuentas en el estudio de diseño SweetJane. ' +
    'Apasionado del mundo startup decide conocerlo más a fondo trabajando como ' +
    'director de área y experto en UI/UX en ' +
    'Impackta.\n' +
    'Además del trabajo en distintos estudios, ha impartido clases de UI / UX y de Videomapping en Hangar ' +
    '(Centre de producció i recerca d’arts visuals de Barcelona) y el Workshop Hack.io en el CCCB.\n' +
    'Fernando estudió diseño gráfico y producción multimedia en EscuelaArteGranada, tiene un postgrado UI/UX y ' +
    'un máster en Digital Media Design en ELISAVA.',
    shortDescription: 'Fernando comenzó su trayectoria profesional en el estudio de diseño',
  },
  {
    imagePath: '/img/09_Brunilda_Garcia.jpg',
    profilePath: 'brunilda-garcia',
    linkedinPath: 'https://www.linkedin.com/in/brunilda-garc%C3%ADa-trabal-2aa17495/',
    name: 'Brunilda Garcia',
    title: 'Lawyer',
    description: 'Graduada en Derecho y Máster en Abogacía por la Universidad Pompeu Fabra de Barcelona, Brunilda ' +
    'comenzó su trayectoria profesional como asesora financiera en Banca Privada en Abante Asesores. Posteriormente, ' +
    'se incorporó como abogado en el departamento mercantil del despacho Rousaud Costas Duran S.L.P. (RCD), donde ' +
    'consolidó sus conocimientos durante tres años en derecho societario, contratos mercantiles y operaciones de M&A,' +
    ' y se especializó asimismo en el asesoramiento legal de startups tecnológicas. Brunilda se incorporó como ' +
    'abogado interno al equipo de The Crowd Angel como responsable del área legal para dar soporte jurídico tanto a ' +
    'la plataforma de crowdfunding como a los inversores y a las startups que son objeto de análisis y de inversión.',
    shortDescription: 'Graduada en Derecho y Máster en Abogacía por la Universidad',
  },
  {
    imagePath: '/img/10_Javier_de_Salas.jpg',
    profilePath: 'javier-de-salas',
    linkedinPath: 'https://www.linkedin.com/in/xavidesalas/',
    name: 'Javier de Salas',
    title: 'Investor Care',
    description: 'Javi estudió Publicidad, Relaciones Públicas y Markerting en ESERP Business School en Barcelona. ' +
    'Más tarde decidió iniciar su carrera profesional como asesor financiero en Banco Mediolanum gestionando su ' +
    'propia cartera de clientes. Durante ese periodo se asoció a EFPA España con la certificación European Investment' +
    ' Practitioner (EIP). Después de un tiempo en el mundo de la banca de inversión, decidió dar el salto al mundo ' +
    'emprendedor de las startups de la mano de The Crowd Angel. Actualmente trabaja en la fase de formalización ' +
    'acompañando a los inversores y emprendedores en el proceso de inversión y post-inversión.',
    shortDescription: 'Javi estudió Publicidad, Relaciones Públicas y Markerting en ESERP',
  },
  {
    imagePath: '/img/11_Juan_Ignacio_Balaguer.jpg',
    profilePath: 'juan-ignacio-balaguer',
    linkedinPath: 'https://www.linkedin.com/in/juanignaciobalaguer/',
    name: 'Juan Ignacio Balaguer',
    title: 'Investment Analyst',
    description: 'Nacho se incorpora al equipo de analistas de The Crowd Angel después de su paso como emprendedor ' +
    'con la intención de obtener así las dos visiones del ecosistema. Inició su carrera profesional como consultor ' +
    'en el equipo de Analytics en Deloitte y después de 4 años decide lanzarse al emprendimiento apasionado por ' +
    'todo lo que lo rodea. Esta última experiencia le lleva a las inversiones en startups y unirse a TCA.Nacho es ' +
    'ingeniero industrial por la Universitat Politécnica de Catalunya y estudió Administración y Dirección de ' +
    'Empresas en la UB.',
    shortDescription: 'Nacho se incorpora al equipo de analistas de The Crowd Angel después',
  },
];

export default teamMembers;



// WEBPACK FOOTER //
// ./src/modules/our-team/teamMembers.tsx